import { render, staticRenderFns } from "./BtnGenerator.vue?vue&type=template&id=1513bcd1&scoped=true"
import script from "./BtnGenerator.vue?vue&type=script&lang=js"
export * from "./BtnGenerator.vue?vue&type=script&lang=js"
import style0 from "./BtnGenerator.vue?vue&type=style&index=0&id=1513bcd1&prod&scoped=true&lang=css"
import style1 from "./BtnGenerator.vue?vue&type=style&index=1&id=1513bcd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513bcd1",
  null
  
)

export default component.exports